import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/recognition/index.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to,from,next) =>{
  //验证token,只有存在token的时候，才能跳转到内容页
  let tokenInfo:any = localStorage.getItem("token");
  const localDataObj = tokenInfo ? JSON.parse(tokenInfo) : {};
  let token = localDataObj.value || ''
  const nowTime = new Date().getTime();
  if (nowTime - localDataObj.time > (1000 * 60 * 60 * 24)) {
    localStorage.removeItem('token');
    token = ''
  }
  if(token || to.path === '/login'){
    next();
  }else{
    console.log('/login')
    next("/login");
  }
})

export default router
